import {Component, AfterViewInit, OnInit, Injector, Input, EventEmitter, Output} from '@angular/core';
import {LandingPageComponent, landingClickState} from '../landingPage/landingPage.component';
import {ChartLayoutModeService} from '../../services/chartLayoutMode/chartLayoutMode.service';
import {QuotePanelsTabsList} from '../../enums/QuotePanelsTabs.list';
import {ChartDisplayMode} from '../../enums/ChartDisplayMode.list';
import {MobileMainView} from '../../enums/mobile-mainViews';
import {DataService} from '../../services/data/data.service';
import {LandingPageClickStateService} from '../../services/landingPageClickStateService/landingPageClickState.service';
import {chartLinesService} from '../../services/chartLinesService';

@Component({
  selector: 'app-mobile-landing-page',
  template: require('./mobile-landing-page.component.html'),
  styles: [require('./mobile-landing-page.component.scss')]
})
export class MobileLandingPageComponent extends LandingPageComponent implements OnInit, AfterViewInit {

  constructor(injector: Injector, activeLayoutTypeService: ChartLayoutModeService, public dataService: DataService,  public tradeLinesVisibilityService:chartLinesService) {
    super(injector, activeLayoutTypeService, dataService);

    this.workspace.landingPageClickStateService.subscriber.subscribe(o => {
      console.log('landing page click state change', o);
      this.setState(this.workspace.landingPageClickState, "", false);
    });

    this.workspace.chartDisplayModeService.subscriber.subscribe(o => {
      console.log('change displaymode', o, this.workspace.landingPageClickState);
      //  let settings = this.landingPageTiles.tiles.find(x => x.label.toLowerCase().indexOf(o) > -1);
      //  if (settings) {
      //    this.setState(settings.clickStateUpdate, settings.label);

      //  }
    });

    if(this.dataService.AllowScannerMobile) {
      const appstoreTile = {
        label: "App Store",
        image: "/images/pieronek-tr.png",
        linkPage: null,
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.ENTSIGNALS,
          chartGridMode: '4',
          showPanel: true,
          activeMobileView: MobileMainView.SHOP
        }
      }

      const scanner = {
        label: "Scanner",
        image: "/images/landing-page/SCANNER.png?v=5",
        linkPage: null,
        premium: true,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SCANNER,
          //     displayMode:ChartDisplayMode.ENTSIGNALS,
          //    chartGridMode:'4',
          showPanel: true,
          activeMobileView: MobileMainView.SCANNER
        }
      }
  //    this.quickBarTiles.tiles.push(scanner);
  //    this.quickBarTiles.tiles.push(appstoreTile);

      //this.landingPageTiles.tiles.push(appstoreTile);
    }
  }


  @Output('update')
  change: EventEmitter<boolean | string> = new EventEmitter<boolean | string>();

  private _curentHeaderHeight: number = 0;
  public get curentHeaderHeight(): number {
    return this._curentHeaderHeight;
  }
  public set curentHeaderHeight(value: number) {
    this._curentHeaderHeight = value;
  }

  @Input() public set headerHeight(v: any) {
    this.curentHeaderHeight = v;
  }


  public getHeightStyle() {
    return {
      "height": `calc(100% - ${ this.curentHeaderHeight }px)`
    };
  }


  ngOnInit() {}
  ngAfterViewInit() {}


  public landingPageTiles: IlandingPageMobile = {
    tiles: [
      {
        label: "Quotes",
        image: "/images/landing-page/Quotes.png?v=5",
        linkPage: null,
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.WIZARD,
          chartGridMode: '4',
          showPanel: true,
          activeMobileView: MobileMainView.PANEL
        }
      },
      {
        label: "Tradedesk",
        image: "/images/landing-page/Tradedesk.png?v=5",
        linkPage: null,
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.WIZARD,
          chartGridMode: '4',
          showPanel: true,
          activeMobileView: MobileMainView.TRADEDESK
        }
      },
      {
        label: "Scanner",
        image: "/images/landing-page/SCANNER.png?v=5",
        linkPage: null,
        premium: true,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SCANNER,
          //     displayMode:ChartDisplayMode.ENTSIGNALS,
          //    chartGridMode:'4',
          showPanel: true,
          activeMobileView: MobileMainView.SCANNER
        }
      },
      {
        label: "App Store",
        image: "/images/landing-page/App-Store-Logo.png?v=5",
        linkPage: null,
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.ENTSIGNALS,
          chartGridMode: '4',
          showPanel: true,
          activeMobileView: MobileMainView.SHOP
        }
      },
      // {
      //   label: "Wizard",
      //   image: "/images/landing-page/Wizard.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.SYMBOL,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.CHARTING
      //   }
      // },
      {
        label: "Charting",
        image: "/images/landing-page/Charting.png?v=5",
        linkPage: null,
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.CHARTING,
          chartGridMode: '4',
          showPanel: true,
          activeMobileView: MobileMainView.CHARTING
        }
      },
      // {
      //   label: "Entry Signals",
      //   image: "/images/landing-page/Entry-Signals.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.SYMBOL,
      //     displayMode: ChartDisplayMode.ENTSIGNALS,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.CHARTING
      //   }
      // },
      // {
      //   label: "Monitor",
      //   image: "/images/landing-page/MONITOR.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.MONITOR,
      //     displayMode: ChartDisplayMode.ENTSIGNALS,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.PANEL
      //   }
      // },
      // {
      //   label: "TI Wizard",
      //   image: "/images/landing-page/TI-Wizard.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.WIZARD,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '1',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.PANEL
      //   }
      // },
      {
        label: "Baskets",
        image: "/images/landing-page/Baskets.png?v=5",
        linkPage: null,
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.WIZARD,
          chartGridMode: '4',
          showPanel: true,
          showTradedesk: true,
          activeBasket: true,
          activeMobileView: MobileMainView.PANEL
        }
      },
      // {
      //   label: "Alerts",
      //   image: "/images/landing-page/alerts.png?v=6",
      //   linkPage: null,
      //   premium: true,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.ALERTS,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.PANEL
      //   }
      // },
      // {
      //   label: "Social",
      //   image: "/images/landing-page/Social.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.SOCIAL,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.PANEL
      //   }
      // },
      // {
      //   label: "Challenge",
      //   image: "/images/landing-page/New-PT-Challenges-Logo.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.LEADERBOARD,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     showChallengeInfo: true,
      //     activeMobileView: MobileMainView.PANEL
      //   }
      // },
      // {
      //   label: "Coaching",
      //   image: "/images/landing-page/Coaching.png?v=5",
      //   linkPage: "https://premieretrade.com/custom-coaching/",
      //   premium: true,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.LEADERBOARD,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '1',
      //   }
      // },
      // {
      //   label: "Quickstart",
      //   image: "/images/landing-page/1-Minute.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.SYMBOL,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '4',
      //     showTutorialPanel: false,
      //     showTutorialVideo: 'wa3aqbaede'
      //   }
      // },
    ]
  }

  public quickBarTiles: IlandingPageMobile = {
    tiles: [
      {
        label: "Add funds",
        image: "/images/quickbar/Add-Funds.png?v=5",
        linkPage: this.workspace.addFundsUrl(),
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.WIZARD,
          chartGridMode: '4',
          showPanel: true,
          activeMobileView: MobileMainView.PANEL
        }
      },
      {
        label: "Live Accounts",
        image: "/images/quickbar/Live-Accounts.png?v=5",
        linkPage: this.workspace.openAccountUrl(),
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.WIZARD,
          chartGridMode: '4',
          showPanel: true,
          activeMobileView: MobileMainView.TRADEDESK
        }
      },
      // {
      //   label: "Wizard",
      //   image: "/images/quickbar/Wizard.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.SYMBOL,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.CHARTING
      //   }
      // },
      {
        label: "Tradedesk",
        image: "/images/quickbar/tradedesk.png?v=5",
        linkPage: null,
        premium: false,
        clickStateUpdate: {
          panel: QuotePanelsTabsList.SYMBOL,
          displayMode: ChartDisplayMode.WIZARD,
          chartGridMode: '4',
          showPanel: true,
          activeMobileView: MobileMainView.TRADEDESK
        }
      },
      // {
      //   label: "Training",
      //   image: "/images/quickbar/Training.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.SYMBOL,
      //     displayMode: ChartDisplayMode.ENTSIGNALS,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.CHARTING,
      //     showTutorialPanel: true
      //   }
      // },
      {
        label: "Charting",
        image: "/images/landing-page/Charting.png?v=5",
        linkPage: null,
        premium: false,
        clickStateUpdate: {
          showPanel: true,
          displayMode: ChartDisplayMode.CHARTING,
          activeMobileView: MobileMainView.CHARTING
        }
      },
      // {
      //   label: "Challenge",
      //   image: "/images/landing-page/PT-Challenge-In-App.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.LEADERBOARD,
      //     displayMode: ChartDisplayMode.WIZARD,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     showChallengeInfo: true,
      //     activeMobileView: MobileMainView.PANEL
      //   }
      // },
      // {
      //   label: "Entry Signals",
      //   image: "/images/landing-page/Entry-Signals.png?v=5",
      //   linkPage: null,
      //   premium: false,
      //   clickStateUpdate: {
      //     panel: QuotePanelsTabsList.SYMBOL,
      //     displayMode: ChartDisplayMode.ENTSIGNALS,
      //     chartGridMode: '4',
      //     showPanel: true,
      //     activeMobileView: MobileMainView.CHARTING
      //   }
      // },
    ]
  };












  public setState(state: landingClickState, label: string, update: boolean = true) {
    if(update) {
      this.workspace.landingPageClickState = state;
    }

    this.workspace.showLoaderComponent = true;
    this.workspace.currentLoadedTitle = label;


    this.tradeLinesVisibilityService.resetTradeLines();


    if(state.panel != undefined) {
      if(state.panel != QuotePanelsTabsList.SCANNER)
        this.workspaceService.data.activeTab = state.panel;
    }


    if(state.displayMode != undefined) {
      this.workspace.chartDisplayMode = state.displayMode;

      if(state.displayMode != ChartDisplayMode.ENTSIGNALS)
        this.workspace.lastChartViewNoEntry = state.displayMode;

      // this.activeLayoutTypeService.subscriber.next(state.chartGridMode);
    }


    this.workspace.showLandingPage = false;
    this.workspace.tutorialPanelShown = false;

    if(state.showTutorialPanel == true)
      this.workspace.tutorialPanelShown = true;

    if(state.showTutorialVideo != null)
      this.workspace.activeTutorialVideo = state.showTutorialVideo;

    if(state.showPanel == true)
      this.showQuotePanel = state.showPanel


    if(state.showChallengeInfo == true)
      //this.showChallengeInfo();


    if(state.showTradedesk == true)
      this.workspace.showTradeDesk = true;

    if(state.activeMobileView != undefined) {
      this.workspace.showMobileLandingPage = false;
      this.workspace.mobileView = state.activeMobileView;

    }
    let emitVal: boolean | string = true;
    if(state.activeBasket) {

      this.workspace.activeBasket = 0;
      emitVal = "basket"

    }

    window.location.hash = '#' + label;

    //if(state.showTutorialPanel)

    if(state.panel != 'scanner') {
      this.workspace.showScannerPage = false;
    }
    else {
      this.workspace.showScannerPage = true;
    }

    this.increment(emitVal);



  }

  increment(val?: any) {
    this.change.emit(val);
  }


  public get horizontalMode() {
    return this.workspace.horizontalMode
  }


}

export interface IlandingPageMobile {
  tiles: landingPageTileMobile[];
}

export interface landingPageTileMobile {
  image: string;
  label: string;
  premium: boolean,
  clickStateUpdate: landingClickState;
  linkPage: string | null
}

